import session from "@/api/session";

export default {
  getDemosList(filters) {
    return session.get(`/voip/demos/`, { params: filters,  paramsSerializer: params => new URLSearchParams(params).toString() });
  },

  getDemoById(id) {
    return session.get(`/voip/demos/${id}/`);
  },
};
